import React from 'react';
import errorImg from '../../assets/images/error.jpg';

const ErrorScene = () => {
  return (
    <div style={{ textAlignLast: 'center' }}>
      <img src={errorImg} style={{ minHeight: '100%', width: '50vw' }} />
      <h3>Something went wrong. Please try again later.</h3>
    </div>
  );
};

export default ErrorScene;
